const regExp = /^(?:http:)?\/\//;

/**
 * Force HTTPS on HTTP links
 * @param {string} url
 * @returns {string}
 */
export default (url) => {
	const shouldSanitize = regExp.test(url);
	return shouldSanitize ? url.replace(regExp, 'https://') : url;
};
